import { TGetNotifyItem } from './interfaces';

export const getNotifyItem: TGetNotifyItem = ({
  t,
  permissions,
  isHostNotifyAvailable,
  openHostMessageModal,
}) => {
  return !permissions?.has('host_command_manage')
    ? null
    : {
        key: 'notify',
        text: t('host.ctx.notify'),
        disabled: ({ locked }) => locked || !isHostNotifyAvailable,
        iconName: 'MessageIcon',
        onClick: openHostMessageModal,
      };
};
